/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import ReactModal from 'react-modal';

import styled from '@emotion/styled';

import { Typography, Typography2 } from '@coursera/cds-core';

import { Information, Warning } from 'bundles/enterprise-admin-skills/svg';
import { Spacer } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-skills';

type Props = {
  isOpen: boolean;
  headingText: React.ReactNode;
  buttons: React.ReactNode;
  informationText?: string;
  warningText?: React.ReactNode;
  notification?: React.ReactNode;
};

const modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '616px',
    padding: '0',
    borderRadius: '0',
  },
  overlay: {
    zIndex: 3001,
  },
};

const HeadingContainer = styled.div({
  backgroundColor: '#2A7E9D',
  width: '100%',
  minHeight: '144px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px',
});

const ContentContainer = styled.div({
  padding: '0 20px',
});

const WarningBox = styled.div({
  padding: '13px 16px',
  border: '1px solid #FFC500',
  background: '#FFF9E6',
  display: 'flex',
});

const TextColumn = styled.div({
  flex: '0 1 calc(100% - 44px)',
});

const SvgColumn = styled.div({
  flex: '0 1 44px',
});

const SkillsNotificationModal: React.FC<Props> = ({
  isOpen,
  headingText,
  buttons,
  warningText,
  informationText,
  notification,
}) => (
  <ReactModal isOpen={isOpen} style={modalStyle}>
    {notification && notification}
    <HeadingContainer>
      <Typography variant="h2semibold" component="h3" color="invertBody" align="center">
        {headingText}
      </Typography>
    </HeadingContainer>
    <ContentContainer>
      <Spacer size={24} />
      {warningText && (
        <div>
          <WarningBox>
            <SvgColumn>
              <Warning />
            </SvgColumn>
            <TextColumn>
              <Typography2 variant="bodyPrimary" component="strong" css={{ textTransform: 'uppercase' }}>
                {_t('Warning')}
              </Typography2>
              <Typography2 component="p">{warningText}</Typography2>
            </TextColumn>
          </WarningBox>
          <Spacer size={24} />
        </div>
      )}
      {informationText && (
        <div>
          <div css={{ display: 'flex' }}>
            <SvgColumn>
              <Information />
            </SvgColumn>
            <TextColumn>
              <Typography2 component="p">{informationText}</Typography2>
            </TextColumn>
          </div>
          <Spacer size={24} />
        </div>
      )}
      {buttons}
      <Spacer size={32} />
    </ContentContainer>
  </ReactModal>
);

export default SkillsNotificationModal;
